import { CARD_FONT_LICENSE, CARD_FONT_LICENSE_URL, CARD_FONT_LIST } from './fontRegistry';
import { OFL_LICENSE_TEXT } from './fontLicenses';

/**
 * カード/PDF に使う埋め込みフォントのライセンス表示 (card-print)。
 *
 * SIL OFL 1.1 §2 が求める「著作権表記とライセンスを利用者が容易に閲覧できる形で含める」を
 * 満たすための **目立たない** 折りたたみ表示。既定は閉じており、開くと各フォントの著作権表記と
 * ライセンス全文を表示する。印刷時は非表示 (card-print-sidebar)。
 */
export function FontLicenseNotice(): JSX.Element {
  return (
    <details className="card-print-sidebar mt-6 text-[10px] text-slate-400">
      <summary className="cursor-pointer select-none hover:text-slate-600 w-fit">
        フォントのライセンス
      </summary>
      <div className="mt-2 grid grid-cols-1 gap-2 max-w-2xl">
        <p>
          カードと PDF には以下の日本語フォントを使用しています (ライセンス: {CARD_FONT_LICENSE})。
        </p>
        <ul className="grid grid-cols-1 gap-0.5">
          {CARD_FONT_LIST.map((f) => (
            <li key={f.id}>
              <span className="text-slate-500">{f.label}</span> — {f.copyright}
            </li>
          ))}
        </ul>
        <p>
          ライセンス全文・FAQ:{' '}
          <a
            href={CARD_FONT_LICENSE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-slate-600"
          >
            {CARD_FONT_LICENSE_URL}
          </a>
        </p>
        <details>
          <summary className="cursor-pointer select-none hover:text-slate-600 w-fit">
            {CARD_FONT_LICENSE} 全文
          </summary>
          <pre className="mt-1 p-2 bg-slate-50 border border-slate-200 rounded whitespace-pre-wrap break-words text-[9px] leading-snug max-h-64 overflow-auto">
            {OFL_LICENSE_TEXT}
          </pre>
        </details>
      </div>
    </details>
  );
}
